const validStopTypes = ['PICKUP', 'DROPOFF'];
const validStages = ['ONROUTE', 'PENDING', 'DONE'];

const stopsStatus = {
  PICKUP: {
    ONROUTE: 'ONROUTE_PICKUP',
    PENDING: 'PENDING_PICKUP',
    DONE: 'LOADED',
  },
  DROPOFF: {
    ONROUTE: 'ONROUTE_DROPOFF',
    PENDING: 'PENDING_DROPOFF',
    DONE: 'DELIVERED',
  },
};

const getStatusTimeForStage = (stage, stop_type, shipmentStateLogs = []) => {
  if (
    !validStages.includes(stage) ||
    !validStopTypes.includes(stop_type) ||
    !shipmentStateLogs.length
  ) {
    return undefined;
  }

  const stateBasedOnStage = stopsStatus[stop_type][stage];

  const stateLog = shipmentStateLogs.find(
    ({ state_to }) => stateBasedOnStage && state_to === stateBasedOnStage
  );

  const timeDone = stateLog ? stateLog.timestamp : undefined;

  return timeDone;
};

export default getStatusTimeForStage;
